import TraductionsInsertForm from "../../components/Traductions/TraductionsInsertForm";




function TraductionsAdd(){


    return (
        <TraductionsInsertForm   ></TraductionsInsertForm>
    );
}
export default TraductionsAdd;